<template name="mediaSnapShot">
  <div class="media-snap-shot" v-show="isMediaSnapShotShow">
    <video id="video" controls autoplay></video>
    <canvas id="canvas"></canvas>
  </div>
</template>

<script type="text/javascript">
import { faceRecognition, uploadPictureByBase64Security } from '@/utils/api';
import { checkNested } from '@/utils/utils';

export default {
  name: 'mediaSnapShot',
  props: {
    inviteId: Number,
    visitorId: Number,
    isMediaSnapShotShow: Boolean,
  },
  data() {
    return {
      maxTryCount: 4,
      tryCount: 0,
      timerId: null,
    };
  },
  watch: {
    isMediaSnapShotShow(isShow) {
      // Reset tryCount and timerId
      this.tryCount = 0;
      this.timerId = null;
      if (isShow) {
        this.showVideo();
      }
    },
  },
  mounted() {
    // style full size && trigger it manually
    window.onresize = this.resizeCanvas;
    this.resizeCanvas();
  },
  methods: {
    resizeCanvas() {
      const canvas = document.getElementById('canvas');
      const { innerWidth, innerHeight } = window;
      canvas.width = innerWidth;
      setTimeout(() => {
        canvas.height = innerHeight;
      }, 0);
    },
    showVideo() {
      const gap = 1000;
      const player = document.getElementById('video');
      const canvas = document.getElementById('canvas');
      const context = canvas.getContext('2d');
      const constraints = {
        video: {
          facingMode: {
            exact: 'environment',
            frameRate: {
              min: 30,
              ideal: 60,
            },
          },
        },
      };
      navigator.mediaDevices.getUserMedia(constraints)
        .then((stream) => {
          player.srcObject = stream;
          let { tryCount } = this;
          const { maxTryCount } = this;
          // Draw the video frame to the canvas.
          this.timerId = setInterval(() => {
            const { inviteId, visitorId } = this.$props;
            context.drawImage(player, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.7);
            uploadPictureByBase64Security({ isDocPhoto: 0, filePath: dataURL }).then((res) => {
              let imgUrl;
              if (checkNested(res, 'data', 'content', 'model')) {
                imgUrl = res.data.content.model;
              }
              return faceRecognition({ ticketId: inviteId, visitorId, fileData: imgUrl });
            }).then((res) => {
              if (checkNested(res, 'data', 'content', 'model')) {
                const { model } = res.data.content;
                if ((model && model.isIdentical) || tryCount === maxTryCount) {
                  // if face recognition return success or reaches maximum try count
                  clearInterval(this.timerId);
                  this.$emit('finishRecognition', res);
                }
                tryCount += 1;
              }
            });
          }, gap);
        });
    },
  },
};
</script>

<style scoped lang="scss">
  #video, #canvas {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
  #canvas {
    display: none;
  }
</style>
